import * as React from 'react';
/**
 * Hook that instantiate a [[GridApiRef]].
 */
export const useGridApiRef = () =>
// TODO v8: initialize with null (see https://github.com/mui/mui-x/issues/16135#issuecomment-2589395230 and https://github.com/mui/mui-x/issues/16000#issuecomment-2567820735)
React.useRef({});